import { render } from "./IncidentsClosed.vue?vue&type=template&id=15ce3cce"
import script from "./IncidentsClosed.vue?vue&type=script&lang=js"
export * from "./IncidentsClosed.vue?vue&type=script&lang=js"

import "./IncidentsClosed.vue?vue&type=style&index=0&id=15ce3cce&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__